@if (loading$ | async) {
  <div id="pause" role="status" aria-live="polite">
    <div class="zf-loader-stack">
      <div class="zf-ring"><span class="zf-ring-dot">ZF</span></div>
      <span class="zf-loader-label">Loading</span>
    </div>
  </div>
}
